module.exports = __webpack_public_path__ + "static/media/highlight_off_black_24dp.a942a436.svg";